import React from 'react';
import type { UnitDefinition, SeatingUnit } from '@/types/seating-v2.types';
import { UnitRenderer } from '../UnitRenderer';

interface GridArrangementProps {
  unit: UnitDefinition;
  units: SeatingUnit[];
  cols?: number;
  spacing: number;
  selectedSeat: number | null;
  onSeatClick: (globalSeatNumber: number) => void;
  onSeatDrop: (globalSeatNumber: number, guestId: number) => void;
}

/**
 * Arranges units in an N×M CSS grid.
 * Used for: banquet, cabaret, cocktail_reception, cluster_pod, lounge
 */
export const GridArrangement: React.FC<GridArrangementProps> = ({
  unit,
  units,
  cols,
  spacing,
  selectedSeat,
  onSeatClick,
  onSeatDrop,
}) => {
  const gridCols = cols || Math.ceil(Math.sqrt(units.length));

  return (
    <div
      className="grid justify-center p-6"
      style={{
        gridTemplateColumns: `repeat(${gridCols}, max-content)`,
        gap: spacing,
      }}
    >
      {units.map((u) => (
        <UnitRenderer
          key={u.unitIndex}
          unitIndex={u.unitIndex}
          label={u.label}
          unit={unit}
          seats={u.seats}
          selectedSeat={selectedSeat}
          onSeatClick={onSeatClick}
          onSeatDrop={onSeatDrop}
        />
      ))}
    </div>
  );
};

export default GridArrangement;
